<script>
  import { createEventDispatcher } from 'svelte'
  export let value = 'en'
  const dispatch = createEventDispatcher()
  function handleLocaleChange(event) {
    event.preventDefault()
    dispatch('locale-changed', event.target.value)
  }
</script>

<div class="box">
  <div>
    <select {value} on:change={handleLocaleChange}>
      <option value="lv">LV</option>
      <option value="en">EN</option>
    </select>
  </div>
</div>

<style>
  .box {
    position: absolute;
    right: 1rem;
    top: 22%;
  }

  .box select {
    background-color: var(--primaryColor);
    color: white;
    padding: 12px;
    width: 80px;
    border: none;
    font-size: 16px;
    box-shadow: 0 5px 25px rgba(0, 0, 0, 0.2);
    appearance: none;
    outline: none;
  }

  .box::before {
    content: '\f13a';
    font-family: FontAwesome;
    position: absolute;
    top: 0px;
    right: 0;
    width: 50%;
    height: 100%;
    text-align: center;
    font-size: 22px;
    line-height: 45px;
    color: #fff;
    background-color: transparent;
    pointer-events: none;
    transition: all 300ms linear;
  }

  .box:hover::before {
    color: var(--headerColor);
    background-color: #fff;
  }

  .box select option {
    padding: 30px;
    color: #fff;
}

@media (max-width: 1020px) {
    .box {
        left: 1rem;
        right: inherit;
        z-index: 4;
    }
}


</style>
